module.exports = __webpack_public_path__ + "static/media/franjatabla.04bd3739.svg";